var _mask, _mask2, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 15,
    viewBox: "0 0 20 15",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    height: 15,
    maskUnits: "userSpaceOnUse",
    width: 20,
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h20v15h-20z",
    fill: "#fff"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "b",
    height: 15,
    maskUnits: "userSpaceOnUse",
    width: 20,
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m0 0v15h20v-15z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd",
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v15h20v-15z",
    fill: "#ffb400"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#c51918",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v3.75h20v-3.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 11.25v3.75h20v-3.75z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1 1h18v-2h-18zm18 0v13h2v-13zm0 13h-18v2h18zm-18 0v-13h-2v13zm0 0h-2c0 1.1046.895431 2 2 2zm18 0v2c1.1046 0 2-.8954 2-2zm0-13h2c0-1.10457-.8954-2-2-2zm-18-2c-1.104569 0-2 .89543-2 2h2z",
    fill: "#000",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpa);
export default __webpack_public_path__ + "static/media/spa.ebdcf9d16a33ab5b7c69823eca06b205.svg";
export { ForwardRef as ReactComponent };